/** User-facing strings and formatters for dispatch notification cards. */

export const NOTIFICATIONS_CONTENT = {
  header: {
    tooltip: 'Notifications',
  },
  panel: {
    empty: 'No Notifications',
    filters: {
      all: 'All',
      messages: 'Messages',
      pickups: 'Pickups',
    },
  },
  logging: {
    toastParseFailed: 'showToastMessageNotification parse failed',
    messageFromDriverParseFailed: 'MessageFromDriver alert parse failed',
  },
} as const;

export const DRIVER_MESSAGE_CONTENT = {
  title: 'Text message',
  stopNamePrefix: '@',
} as const;

export const PICKUP_REVIEW_CONTENT = {
  summaryTitle: 'Pickup needs review',
  moreToReview: (n: number) => `+${n} pickups to be reviewed`,
} as const;

export type DriverNameNumber = {
  driverName?: string;
  driverNumber?: string;
};

export const formatDriverMessageTitle = (
  driver: DriverNameNumber | null | undefined
): string | null | undefined => {
  if (!driver) {
    return null;
  }

  if (driver.driverName) {
    return `${driver.driverName} (${driver.driverNumber})`;
  }

  return driver.driverNumber;
};

export const formatPickupReviewDriverDisplay = (
  driverName: string,
  driverNumber: string
): string => `${driverName} (#${driverNumber})`;
